import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-export-to-excel-button',
  templateUrl: './export-to-excel-button.component.html',
  styleUrls: ['./export-to-excel-button.component.css']
})
export class ExportToExcelButtonComponent implements OnInit {
  constructor() { }

  ngOnInit() {
  }

}
